import {
    Alert,
    Option,
    Paper,
    SearchAutocomplete,
    Select
} from '@deere/fuel-react';
import {
    AlertColor,
    Stack,
    AutocompleteValue,
    Box,
    Button,
    Container,
    Grid,
    InputLabel,
    TextField,
    Typography
} from '@mui/material';
import React, {FC, useEffect} from 'react';
import {useOktaAuth} from '@okta/okta-react';

const MAX_SELECTED_ROLE_ID = 6;
const MAX_STUDENT_ID_LENGTH = 7;
const MAX_ALERT_DISPLAY_TIME = 5000;
let MESSAGE_SEVERITY: AlertColor | undefined = 'success',
    MESSAGE = '';

export const NewAdminRequest: FC<unknown> = () => {
    const {authState} = useOktaAuth();
    const [loading, setLoading] = React.useState(false);
    const [state, setState] = React.useState({
        isMessageVisible: false,
        studentId: '',
        roleNames: [] as string[],
        domainName: '',
        roleIds: [],
        domainIds: [] as AutocompleteValue<any, any, any, any>[],
        userName: '',
        isSubmitDisabled: true
    });

    const handleRoleChange = (event: any): boolean => {
        if (event.currentTarget.selectedOptions.length > MAX_SELECTED_ROLE_ID) {
            MESSAGE = 'You may select maximum 6 roles.';
            MESSAGE_SEVERITY = 'info';
            setState((prevState) => ({
                ...prevState,
                isMessageVisible: !prevState.isMessageVisible
            }));
            setTimeout(() => {
                setState((prevState) => ({
                    ...prevState,
                    isMessageVisible: !prevState.isMessageVisible
                }));
            },
            MAX_ALERT_DISPLAY_TIME);
            return false;
        }
        const selectedValue = [...event.currentTarget.selectedOptions].map((option) =>
            option.value);

        setState((prevState) => ({
            ...prevState,
            roleNames: selectedValue
        }));
        return true;
    };

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/domains`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Authorization': `Bearer ${authState?.accessToken?.accessToken}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                setState((prevState) => ({
                    ...prevState,
                    domainIds: data
                }));
                return null;
            }).catch((error) => {
                console.log(error);
            });
    }, [authState]);

    useEffect(() => {
        fetch(`${process.env.REACT_APP_BACKEND_URL}/roles`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Authorization': `Bearer ${authState?.accessToken?.accessToken}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                setState((prevState) => ({
                    ...prevState,
                    roleIds: data
                }));
                return null;
            }).catch((error) => {
                console.log(error);
            });
    }, [authState]);

    const showUsername = (): void => {
        if (!state.studentId || state.studentId.length < MAX_STUDENT_ID_LENGTH) {
            return;
        }
        fetch(`${process.env.REACT_APP_BACKEND_URL}/adminname/${state.studentId}`, {
            method: 'GET',
            mode: 'cors',
            headers: {
                'Authorization': `Bearer ${authState?.accessToken?.accessToken}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*'
            }
        })
            .then((res) => res.json())
            .then((json) => {
                setState((prevState) => ({
                    ...prevState,
                    userName: json.username,
                    isSubmitDisabled: false
                }));
                return null;
            })
            .catch((error) => {
                console.log(error);
            });
    };

    const handleSubmit = (event: any): void => {
        event.preventDefault();
        state.isSubmitDisabled = true;
        const {
            studentId, roleNames, domainName
        } = state;
        const data =
            {
                studentId,
                roleNames,
                domainName
            };

        setLoading(true);

        fetch(`${process.env.REACT_APP_BACKEND_URL}/addadmin`, {
            method: 'POST',
            mode: 'cors',
            headers: {
                'Authorization': `Bearer ${authState?.accessToken?.accessToken}`,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*'
            },
            body: JSON.stringify(data)
        })
            .then((res) => res.json())
            .then((json) => {
                MESSAGE = json.message;
                if (MESSAGE !== 'Request submitted successfully') {
                    MESSAGE_SEVERITY = 'error';
                } else {
                    MESSAGE_SEVERITY = 'success';
                }
                setLoading(false);
                setState((prevState) => ({
                    ...prevState,
                    isMessageVisible: !prevState.isMessageVisible
                }));
                setTimeout(() => {
                    setState((prevState) => ({
                        ...prevState,
                        isMessageVisible: !prevState.isMessageVisible,
                        isSubmitDisabled: false
                    }));
                },
                MAX_ALERT_DISPLAY_TIME);
                return null;
            })
            .catch(() => null);
    };

    return (

        <Container
            sx={{
                textAlign: 'center',
                paddingTop: '3rem'
            }}
        >

            <Box
                alignItems='center'
                display='flex'
                justifyContent='center'
            >
                <Box
                    maxWidth='50rem'
                    width='100%'
                >
                    <Paper
                        variant='outlined'
                    >
                        {state.isMessageVisible &&
                            <Stack
                                spacing={2}
                                sx={
                                    {
                                        width: '100%'
                                    }
                                }
                            >
                                <Alert
                                    variant={MESSAGE_SEVERITY}
                                >
                                    <strong> {MESSAGE}</strong>
                                </Alert>
                            </Stack>
                        }
                        <form onSubmit={handleSubmit}>
                            <Box
                                pb={10}
                                pl={20}
                                pr={20}
                                pt={10}
                            >
                                <Grid
                                    alignItems='flex-start'
                                    container
                                    spacing={4}
                                >
                                    <Grid
                                        item
                                        xs={12}
                                    >
                                        <Typography
                                            sx={
                                                {
                                                    textAlign: 'center'
                                                }
                                            }
                                            variant='h4'
                                        >
                                            {'Admin Request Form'}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        display={'flex'}
                                        item
                                        xs={4}
                                    >
                                        <InputLabel
                                            required
                                            sx={
                                                {
                                                    textAlign: 'right'
                                                }
                                            }
                                        >
                                            {'Admin Username'}
                                        </InputLabel>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={8}
                                    >
                                        <TextField
                                            hiddenLabel
                                            id='studentId'
                                            inputProps={{
                                                style: {
                                                    textAlign: 'left'
                                                }
                                            }}
                                            name='studentId'
                                            onBlur={showUsername}
                                            onChange={(event): void => {
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    studentId: event.target.value
                                                }));
                                            }}
                                            placeholder='Enter student id or Okta username'
                                            required
                                            type='text'
                                            value={state.studentId}
                                        />
                                    </Grid>
                                    <Grid
                                        display={'flex'}
                                        item
                                        xs={4}
                                    >
                                        <InputLabel
                                            sx={
                                                {
                                                    textAlign: 'right'
                                                }
                                            }
                                        >
                                            {'Admin Name'}
                                        </InputLabel>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={8}
                                    >
                                        <Typography
                                            sx={
                                                {
                                                    textAlign: 'left'
                                                }
                                            }
                                            variant='h4'
                                        >
                                            {state.userName}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        display={'flex'}
                                        item
                                        xs={4}
                                    >
                                        <InputLabel
                                            required
                                            sx={
                                                {
                                                    textAlign: 'right'
                                                }
                                            }
                                        >
                                            {'Role ID'}
                                        </InputLabel>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={8}
                                    >
                                        <Select
                                            hasSearch
                                            multiple
                                            name='roleId'
                                            onChange={handleRoleChange}
                                            value={state.roleNames}
                                        >
                                            {state.roleIds.map((roleId) => (
                                                <Option
                                                    key={roleId}
                                                    value={roleId}
                                                >
                                                    {roleId}
                                                </Option>))}
                                        </Select>
                                        <Typography
                                            sx={
                                                {
                                                    bgcolor: '#e5f6fd',
                                                    textAlign: 'left'
                                                }
                                            }
                                        >
                                            {'You may select maximum 6 roles.'}
                                        </Typography>
                                    </Grid>
                                    <Grid
                                        display={'flex'}
                                        item
                                        xs={4}
                                    >
                                        <InputLabel
                                            required
                                            sx={
                                                {
                                                    textAlign: 'left'
                                                }
                                            }
                                        >
                                            {'Administrator Domain'}<br/>{'Permissions'}
                                        </InputLabel>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={8}
                                    >
                                        <SearchAutocomplete
                                            TextFieldProps={{
                                                InputProps: {
                                                    style: {
                                                        textAlign: 'left'
                                                    }
                                                },
                                                name: 'domainId',
                                                placeholder: 'Select the domain',
                                                required: true,
                                                size: 'medium'
                                            }}
                                            id='domainId'
                                            isOptionEqualToValue={(option, value): boolean => option.value === value.value}
                                            onChange={(event, value): void => {
                                                setState((prevState) => ({
                                                    ...prevState,
                                                    domainName: String(value?.value)
                                                }));
                                            }}
                                            options={state.domainIds}

                                        />
                                    </Grid>
                                    <Grid
                                        alignItems='center'
                                        columnSpacing={2}
                                        container
                                        item
                                        justifyContent='center'
                                        xs={12}
                                    >
                                        <Grid item>
                                            <Button
                                                disabled={state.isSubmitDisabled}
                                                type='submit'
                                                variant='primary'
                                            >
                                                {loading ? <>{'Submitting Request...'}</> : <>{'Submit'}</>}
                                            </Button> &nbsp;&nbsp;
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    </Paper>
                </Box>
            </Box>
        </Container>
    );
};
